module.exports = __webpack_public_path__ + "img/intro-3.6ad73022.jpg";